module.exports = __webpack_public_path__ + "static/androidBannerMakingMats-458aac0a9cbaed046137b60408700723.png";